import React from 'react'
import { Link } from 'react-router-dom'
import karachiImage from '../assets/mobile-app-development-karachi-pakistan.png'
import houstonImage from '../assets/mobile-app-development-houston-usa.png'
import dubaiImage from '../assets/mobile-app-development-dubai-uae.png'
import riyadhImage from '../assets/mobile-app-development-riyadh-saudi.png'

const locations = [
  { city: 'Karachi', country: 'Pakistan', route: '/app-development/', image: karachiImage, description: 'Mobile app strategy, design, development, QA, and launch support for local and global product teams.' },
  { city: 'Houston', country: 'United States', route: '/app-development-houston/', image: houstonImage, description: 'Custom iOS, Android, and connected mobile products for Houston and US organisations.' },
  { city: 'Dubai', country: 'United Arab Emirates', route: '/app-development-dubai/', image: dubaiImage, description: 'Mobile product discovery, engineering, and delivery for Dubai and UAE businesses.' },
  { city: 'Riyadh', country: 'Saudi Arabia', route: '/app-development-riyadh/', image: riyadhImage, description: 'Practical mobile app development for Riyadh and Saudi Arabia product teams.' }
]

const AppDevelopmentLocations = () => (
  <section className="app-development-locations py-5" aria-labelledby="app-development-locations-heading">
    <div className="container">
      <div className="text-center mb-4">
        <h2 className="h5 fw-bold mb-3" style={{ color: '#6565ff' }}>OUR LOCATIONS</h2>
        <h2 id="app-development-locations-heading" className="display-5 fw-bold text-light">Mobile App Development Locations</h2>
        <p className="lead text-light text-opacity-75 mx-auto" style={{ maxWidth: 820 }}>Explore location-focused mobile app development services, local market context, and practical product delivery support.</p>
      </div>
      <div className="row">
        {locations.map((location) => (
          <div key={location.route} className="col-lg-3 col-md-6 col-12 my-2">
            <Link to={location.route} className="text-decoration-none" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' })} aria-label={`Explore mobile app development in ${location.city}, ${location.country}`}>
              <article className="card app-development-type-card h-100 overflow-hidden rounded-4 text-light" style={{ backgroundColor: '#0f0f12', border: '1px solid rgba(101, 101, 255, .55)' }}>
                <div className="app-development-type-card-image">
                  <img src={location.image} className="w-100 h-100" width="720" height="540" alt={`${location.city}, ${location.country} mobile app development`} loading="lazy" />
                </div>
                <div className="card-body d-flex flex-column p-4">
                  <p className="small text-uppercase mb-2" style={{ color: '#8f8fff', letterSpacing: 1 }}>{location.country}</p>
                  <h3 className="h5 fw-bold">{location.city}</h3>
                  <p className="text-light text-opacity-75 mb-4">{location.description}</p>
                  <span className="mt-auto" style={{ color: '#8f8fff' }}>Explore location <i className="fa fa-arrow-right ms-2" aria-hidden="true"></i></span>
                </div>
              </article>
            </Link>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default AppDevelopmentLocations
